/**
 * AdMob banner helper — bottom-anchored, hidden during profile cards.
 * In-feed ads use the HTML AdCard; banner supplements only on native when ad card is visible.
 */

import { Capacitor } from '@capacitor/core'

export const ADMOB_BANNER_TEST = 'ca-app-pub-3940256099942544/6300978111'

let initialized = false
let bannerVisible = false

export function adsNativeAvailable(): boolean {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android'
}

export async function initAdMob(): Promise<boolean> {
  if (!adsNativeAvailable()) return false
  if (initialized) return true
  try {
    const { AdMob } = await import('@capacitor-community/admob')
    await AdMob.initialize({ initializeForTesting: true })
    initialized = true
    return true
  } catch (e) {
    console.warn('AdMob init failed', e)
    return false
  }
}

/** Show a small banner while the in-feed ad card is on screen */
export async function showAdCardBanner(
  adUnitId = import.meta.env.VITE_ADMOB_BANNER_ID || ADMOB_BANNER_TEST,
): Promise<void> {
  if (!(await initAdMob()) || bannerVisible) return
  try {
    const { AdMob, BannerAdSize, BannerAdPosition } = await import('@capacitor-community/admob')
    await AdMob.showBanner({
      adId: adUnitId,
      adSize: BannerAdSize.ADAPTIVE_BANNER,
      position: BannerAdPosition.BOTTOM_CENTER,
      margin: 72,
      isTesting: true,
    })
    bannerVisible = true
  } catch (e) {
    console.warn('AdMob banner failed', e)
  }
}

export async function hideAdCardBanner(): Promise<void> {
  if (!bannerVisible || !adsNativeAvailable()) return
  try {
    const { AdMob } = await import('@capacitor-community/admob')
    await AdMob.hideBanner()
    bannerVisible = false
  } catch {
    bannerVisible = false
  }
}
